import RefreshIcon from '@mui/icons-material/Refresh';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { type PromptMode, promptModes } from '../constants.ts';

type NewSearchButtonProps = {
  loading: boolean;
  mode: PromptMode;
  hasError: boolean;
  /** When true, the button stays visible in preview even if the last search errored (audience flow). */
  allowDuringError?: boolean;
  onClick: () => void;
};

export const NewSearchButton = ({
  loading,
  mode,
  hasError,
  allowDuringError = false,
  onClick,
}: NewSearchButtonProps) => {
  const { t } = useTranslation();

  if ((hasError && !allowDuringError) || loading || mode !== promptModes.PREVIEW_MODE) return null;

  return (
    <Button
      variant="text"
      color="primary"
      sx={theme => ({ position: 'absolute', left: theme.spacing(4), borderRadius: 2 })}
      onClick={onClick}
    >
      <RefreshIcon aria-label={t('Refresh Icon')} sx={{ mr: 1 }} />
      {t('New Search')}
    </Button>
  );
};
